export default __webpack_public_path__ + "static/media/nunito.bold.c8d0ed25.ttf";